import Vue from "vue";
import {
  DynamicService
} from "@/common/api.service";

import {
  MANUFACTURER_PUBLISH,
  MANUFACTURER_EDIT,
  MANUFACTURER_DELETE,
  MANUFACTURER_RESET_STATE,
  FETCH_MANUFACTURER,
  FETCH_MANUFACTURERS
} from "./actions.type";

import {
  RESET_STATE,
  SET_MANUFACTURER,
  FETCH_END_MANUFACTURERS,
  FETCH_START_MANUFACTURERS
} from "./mutations.type";

const initialState = {
  manufacturer: {
    name: "",
    brandSymbol: null,
    carModels: []
  },
  manufacturers: [],
  isLoading: true,
  manufacturersCount: 0
};

// needed cause service is dynamic
const resource = "CarManufacturers"

export const state = { ...initialState };

export const actions = {
  async [FETCH_MANUFACTURER](context, { slug, prevManufacturer, params}) {
    // avoid extronuous network call if manufacturer exists
    if (prevManufacturer !== undefined) {
      return context.commit(SET_MANUFACTURER, prevManufacturer);
    }

    const { data } = await DynamicService.get(resource, slug, params);
    context.commit(SET_MANUFACTURER, data);
    return data;
  },
  [FETCH_MANUFACTURERS]({ commit }, params) {
    commit(FETCH_START_MANUFACTURERS);
    return DynamicService.query(resource, params)
      .then(({ data }) => {
        // console.log("data in fetch manufacturers")
        // console.log(data)
        commit(FETCH_END_MANUFACTURERS, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  [MANUFACTURER_PUBLISH]({ state }) {
    return DynamicService.create(resource, state.manufacturer);
  },
  [MANUFACTURER_DELETE](context, slug) {
    return DynamicService.destroy(resource, slug);
  },
  [MANUFACTURER_EDIT]({ state }) {
    return DynamicService.update(resource, state.manufacturer.slug, state.manufacturer);
  },
  [MANUFACTURER_RESET_STATE]({ commit }) {
    commit(RESET_STATE);
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
  [SET_MANUFACTURER](state, manufacturer) {
    state.manufacturer = manufacturer;
  },
  [RESET_STATE]() {
    for (let f in state) {
      Vue.set(state, f, initialState[f]);
    }
  },
  [FETCH_START_MANUFACTURERS](state) {
    state.isLoading = true;
  },
  [FETCH_END_MANUFACTURERS](state, manufacturers) {
    state.manufacturers = manufacturers;
    state.manufacturersCount = manufacturers.length;
    state.isLoading = false;
  }
};

const getters = {
  manufacturer(state) {
    return state.manufacturer;
  },
  manufacturersCount(state) {
    return state.manufacturersCount;
  },
  manufacturers(state) {
    return state.manufacturers;
  },
  manufacturerIsLoading(state) {
    return state.isLoading;
  },
};

export default {
  state,
  actions,
  mutations,
  getters
};
